import React from 'react';
import { ExplorationPath } from '@models/feature-space';

export const ExplorationPathHeader: React.FC<{
  explorationPath: ExplorationPath;
  explorationPathIndex: number;
}> = props => {
  const { targetTable, sourceTable, targetColumns, sourceColumns } =
    props.explorationPath;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'baseline',
        padding: '12px 16px',
        gap: '8px',
        background: 'var(--c-catskill-white)',
      }}
    >
      <div>
        {targetTable}[
        <span
          style={{
            color: 'var(--c-blue-700)',
            fontWeight: '500',
          }}
        >
          {targetColumns.join(', ')}
        </span>
        ] - {sourceTable}[
        <span
          style={{
            color: 'var(--c-blue-700)',
            fontWeight: '500',
          }}
        >
          {sourceColumns.join(', ')}
        </span>
        ]
      </div>
    </div>
  );
};
